import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FlexRow } from 'ui-components/components/flex';
import messages from '../messages';
import style from './edit-amount-summary-modal.module.less';

export const EditAmountSummaryInstructions = () => {
  return (
    <FlexRow className={style.instructions}>
      <FormattedMessage {...messages.editAmountsHeader} />
    </FlexRow>
  );
};
